// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2ez2u","comment":"styles_comment__26Alx"};